import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

//For free news api

const headers = {
  'x-rapidapi-host': 'free-news.p.rapidapi.com',
  'x-rapidapi-key': '682fe1eb1emsh8c2cde61ce0f48ep1a3cc8jsne608cbb82241',
};

const baseUrl = 'https://free-news.p.rapidapi.com/v1/';

export const newsApi = createApi({
  reducerPath: 'newsApi',
  baseQuery: fetchBaseQuery({ baseUrl: baseUrl }),
  endpoints: (builder) => ({
    getNews: builder.query({
      query: ({ page_size,topic }) => ({
        url: `/search?q=${topic}&page_size=${page_size}`,
        headers: headers,
      }),
    }),
  }),
});

export const { useGetNewsQuery } = newsApi;